import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const Footnote = ({ className, ...props }) => (
  <p
    className={cn(
      "text-12 text-grey-65 tracking-tigher text-center font-medium",
      className
    )}
    {...props}
  />
)

export const AuthenticateContent = ({ className, ...props }) => (
  <div
    className={cn(
      "tablet:flex-row tablet:text-left tablet:w-(--tablet-width) desktop:w-(--desktop-width) flex h-full flex-col items-center text-center",
      className
    )}
    style={{
      "--desktop-width": "855px",
      "--tablet-width": "640px",
    }}
    {...props}
  />
)

export const AuthenticateModalTitle = ({ className, ...props }) => (
  <h1
    className={cn("text-20 leading-24 mb-16 text-center font-bold", className)}
    {...props}
  />
)

export const Separator = ({ className, children, ...props }) => (
  <div
    className={cn(
      "text-12 leading-18 tracking-tigher relative flex items-center text-center font-medium",
      "before:mr-32 before:flex-grow before:border-b",
      "after:ml-32 after:flex-grow after:border-b",
      className
    )}
    {...props}
  >
    {children}
  </div>
)

export const LogoContainer = ({ className, ...props }) => (
  <div
    className={cn("mb-16 flex justify-center gap-16", className)}
    {...props}
  />
)

export const HaveAccount = ({ className, ...props }) => (
  <p
    className={cn(
      "text-14 leading-18 tracking-tigher text-center font-medium",
      className
    )}
    {...props}
  />
)

Footnote.propTypes = {
  className: PropTypes.string,
}
Separator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
LogoContainer.propTypes = {
  className: PropTypes.string,
}
HaveAccount.propTypes = {
  className: PropTypes.string,
}
AuthenticateContent.propTypes = {
  className: PropTypes.string,
}
AuthenticateModalTitle.propTypes = {
  className: PropTypes.string,
}
